module.exports = __webpack_public_path__ + "img/o-childrens-candy-house.2fb2d4e9.jpg";